import { useReveal } from "@/hooks/useReveal";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Testimonials from "@/components/site/Testimonials";
import PhotoGallery from "@/components/site/PhotoGallery";
import VideoGallery from "@/components/site/VideoGallery";
import FAQ from "@/components/site/FAQ";
import Booking from "@/components/site/Booking";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";

export default function LandingPage() {
  useReveal();
  return (
    <div data-testid="landing-page" className="relative">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <WhyChooseUs />
        <Testimonials />
        <PhotoGallery />
        <VideoGallery />
        <FAQ />
        <Booking />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
